import { makeAutoObservable } from "mobx";

/**
 * 환경설정 Model
 */
export default class ConfigModel {
  private _defaultLocale!: string;
  private _systemMode!: string;

  public constructor({locale, systemMode}:{locale?:string, systemMode?:string}) {
    if (locale != null) {
      this._defaultLocale = locale;
    }
    if (systemMode != null) {
      this._systemMode = systemMode;
    }

    makeAutoObservable(this);
  }

  public get defaultLocale() {
    return this._defaultLocale;
  }

  public set defaultLocale(defaultLocale: string) {
    this._defaultLocale = defaultLocale;
  }

  get systemMode(): string {
    return this._systemMode;
  }

  set systemMode(value: string) {
    this._systemMode = value;
  }
}
